<template>
  <div>
    <div class="contactList" v-for="(contact, index) in data" :key="index">
      <b-row>
        <b-col>
          Telephone : {{ contact.telephone }} <br />
          Phone : {{ contact.phone }}<br />
          Email:{{ contact.email }}
        </b-col>
        <b-col class="text-right">
          <b-button @click="editContact(index)" size="sm">Edit</b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: [],
    },
  },
  methods: {
    editContact(index) {
      this.$emit("editContact", index);
    },
  },
};
</script>
<style>
.contactList {
  width: 100%;
  padding: 10px 20px;
  background-color: #f4f4f4;
  border-left: 4px solid #52bc00;
  margin-bottom: 6px;
}
</style>
